"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSearchResultsData = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
/* istanbul ignore file @preserve */ /**
 * Fetch function that fetches data for Search Page from GraphQL.
 */ const getSearchResultsData = async (param)=>{
    let { tenant, staticApiUrl } = param;
    const staticApiClient = new _staticApiClientReact.ApiClient({
        baseUrl: staticApiUrl,
        tenant
    });
    const { data: productBoxConfiguration } = await (0, _staticApiClientReact.getTenantApplicationsProductboxConfiguration)(staticApiClient, tenant);
    return {
        productBoxConfiguration
    };
};
exports.getSearchResultsData = getSearchResultsData;
